/**
 * Client-side helper for emitting Listings telemetry events.
 *
 * Posts to /api/telemetry/listings, which derives user_id from the session
 * (never from this client) and inserts via the service-role client.
 *
 * Fire-and-forget. Failures are silent — a telemetry blip should never
 * disrupt the user.
 */

import type { ListingsEventName } from './emit';

export interface ClientTelemetryInput {
  event: ListingsEventName;
  caseId?: string | null;
  listingId?: string | null;
  metadata?: Record<string, unknown> | null;
}

export function emitListingsEventClient(input: ClientTelemetryInput): void {
  try {
    const body = JSON.stringify(input);
    // Prefer sendBeacon for fire-and-forget; falls back to fetch otherwise.
    if (typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function') {
      const blob = new Blob([body], { type: 'application/json' });
      navigator.sendBeacon('/api/telemetry/listings', blob);
      return;
    }
    void fetch('/api/telemetry/listings', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body,
      keepalive: true,
    });
  } catch {
    // Silent — telemetry must never break the page.
  }
}
